export const CREATING_RESOURCE = 'Creating Resource';
export const UPDATING_RESOURCE = 'Updating Resource';
export const DELETING_RESOURCE = 'Deleting Resource';
export const RETRIEVING_RESOURCES = 'Retrieving Resources';
